import { Menu, MenuItem } from "@snpjs/core";

import { AdminViewType } from "../types/AdminViewType";
import { IAdminViewMenuProps } from "./IAdminViewMenuProps";
import styles from "./AdminViewMenu.module.scss";
import { texts } from "../../../i18n/texts";
import useTranslation from "../../../hooks/useTranslation";
import { canAccessAdminViewType } from "../adminViewPermissions";

/**
 * Menu for selecting an admin view section.
 */
export const AdminViewMenu: React.FC<IAdminViewMenuProps> = (props) => {
  const { t } = useTranslation();
  const canAccess = (view: AdminViewType) =>
    canAccessAdminViewType(props.roles, view);

  return (
    <Menu className={styles.menu}>
      {canAccess(AdminViewType.LICENSE_LOG) && (
        <MenuItem
          active={props.selectedView === AdminViewType.LICENSE_LOG}
          text={t(texts.adminView.licenseLog)}
          onClick={() => props.onSelect(AdminViewType.LICENSE_LOG)}
        />
      )}
      {canAccess(AdminViewType.DOWNLOAD_HISTORY) && (
        <MenuItem
          active={props.selectedView === AdminViewType.DOWNLOAD_HISTORY}
          text={t(texts.adminView.downloadHistory)}
          onClick={() => props.onSelect(AdminViewType.DOWNLOAD_HISTORY)}
        />
      )}
      {canAccess(AdminViewType.PROJECT_TABLE) && (
        <MenuItem
          active={props.selectedView === AdminViewType.PROJECT_TABLE}
          text={t(texts.adminView.projectTable)}
          onClick={() => props.onSelect(AdminViewType.PROJECT_TABLE)}
        />
      )}
      {canAccess(AdminViewType.PRODUCT_MAPPING) && (
        <MenuItem
          active={props.selectedView === AdminViewType.PRODUCT_MAPPING}
          text={t(texts.adminView.productMapping)}
          onClick={() => props.onSelect(AdminViewType.PRODUCT_MAPPING)}
        />
      )}
      {canAccess(AdminViewType.RELEASES) && (
        <MenuItem
          active={props.selectedView === AdminViewType.RELEASES}
          text={t(texts.adminView.releases)}
          onClick={() => props.onSelect(AdminViewType.RELEASES)}
        />
      )}
      {canAccess(AdminViewType.CUSTOMER_TABLE) && (
        <MenuItem
          active={props.selectedView === AdminViewType.CUSTOMER_TABLE}
          text={t(texts.adminView.customerTable)}
          onClick={() => props.onSelect(AdminViewType.CUSTOMER_TABLE)}
        />
      )}
      {canAccess(AdminViewType.PROJECT_ANALYSIS) && (
        <MenuItem
          active={props.selectedView === AdminViewType.PROJECT_ANALYSIS}
          text={t(texts.adminView.projectAnalysis)}
          onClick={() => props.onSelect(AdminViewType.PROJECT_ANALYSIS)}
        />
      )}
      {canAccess(AdminViewType.UPDATE_SYNC) && (
        <MenuItem
          active={props.selectedView === AdminViewType.UPDATE_SYNC}
          text={t(texts.adminView.updateSync)}
          onClick={() => props.onSelect(AdminViewType.UPDATE_SYNC)}
        />
      )}
      {canAccess(AdminViewType.EMAIL_LOGS) && (
        <MenuItem
          active={props.selectedView === AdminViewType.EMAIL_LOGS}
          text={t(texts.adminView.emailLogs)}
          onClick={() => props.onSelect(AdminViewType.EMAIL_LOGS)}
        />
      )}
    </Menu>
  );
};
